// extracted by mini-css-extract-plugin
export default {"eventItem":"item_eventItem__PUYPo","disabledText":"item_disabledText__t4Jl5"};